/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Box from '@mui/material/Box';

import { useStyles } from './styles';
import Thumbnail from '../components/thumbnail';

function Tile (props) {
    const {
        widget = {},
        widgetTheme = {},
        data = {},
        onClick = () => {},
    } = props;

    const classes = useStyles({
        widget,
        widgetTheme,
    });

    function getTileClassName (data) {
        const isApple = data?.value === 'apple';
        return classNames(classes.tile, { [classes.tileAppleShadow]: isApple });
    }

    function renderThumbnail (data) {
        return (
            <Box className={classNames([classes.tileBox])}>
                <img
                    className={getTileClassName(data)}
                    alt={data.name}
                    src={data.logo}
                />
            </Box>
        );
    }

    return (
        <Thumbnail
            view="calendar"
            data={data}
            widget={widget}
            widgetTheme={widgetTheme}
            label={data.name}
            renderThumbnail={renderThumbnail}
            onClick={onClick}
            labelCustomClassName={'ecal-calendar-app-label'}
            thumbnailCustomClassName={'ecal-calendar-item'}
        />); 
}

Tile.propTypes = {
    widget: PropTypes.any,
    widgetTheme: PropTypes.any,
    data: PropTypes.any,
    onclick: PropTypes.func,
};

export default Tile;